<template>
  <div class="activeOrder">
    <div class="activeOrder__header">
      <div class="activeOrder__header__left">
        <div class="activeOrder__header__left__search">
          <i class="adx-ic_search"></i>
          <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
        </div>
      </div>
      <div class="activeOrder__header__right">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
        </div>
      </div>
    </div>

    <adx-table text="Tooltip button" 
      :items.sync="data"
      :loading.sync="isLoading"
      :isEmpty.sync="isEmpty">
    </adx-table>

    <div class="activeOrder__footer">
      <div class="total_order" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Orders</div>
      <adx-pagination
        v-if="!isLoading && !isEmpty"
        @change-page="selectPage"
        :max-page="maxPage"
        :selectedPage="selectedPage"
      />
    </div>
  </div>
</template>

<script>
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import Pagination from '@/components/Pagination'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import Loading from '@/components/Loading/Primary'
import Dropdown2Level from '@/components/Dropdown/Dropdown2Level'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib

export default {
  name: "adx-active-order",
  components: {
    "adx-table": table,
    LabelStatus,
    'adx-dropdown-list': ListDropdown,
    'adx-dropdown-sort': DropdownSort,
    'adx-dropdown-search': DropdownSearch,
    'adx-pagination': Pagination,
    'adx-loading': Loading,
    'dropdown-2-level': Dropdown2Level
  },
  props: {
      
  },
  data() {
    return {
      item: null,
      isInit: true,
      items: [],
      selectedItems:[],
      currentPage: 1,
      maxPage: 1,
      selectedPage: 1,
      count: 0,
      searchBoxValue: '',
      selectedSortValue: 'last_updated',
      selectStatus: '',
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 2,
          'label': 'Price High to Low',
          'value': '-price'
        },
        {
          'id': 3,
          'label': 'Price Low to High',
          'value': 'price'
        },
      ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text-value"
          },
          {
            title: "COMPANY NAME",
            type: "text"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "STATUS",
            type: "statuslabel"
          },
          {
            title: "PRICE",
            type: "money"
          },
          {
            title: "PAYMENT",
            type: "statuslabel"
          },
          {
            title: "START DATE",
            type: "date"
          },
          {
            title: "END DATE",
            type: "date"
          },
          {
            title: "LAST UPDATED",
            type: "date"
          }
        ],
        body: [],
      },
    }
  },
  computed: {
    getFilterParams: function () {
      const params = {
        sort: this.selectedSortValue || undefined,
        search: this.searchBoxValue || undefined,
      }
        return params
    },
    getDataRange: function(){
      return (this.count%15===0 || this.currentPage===1) && this.count>15?this.currentPage*15:(this.currentPage*15-15)+(this.count%15)
    },
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    isLoading: function(){
      return this.$apollo.loading || false
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.$apollo.queries.busOrdersPage.refetch()
      })
    }, 500),
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedSortValue = newValue
        this.$apollo.queries.busOrdersPage.refetch()
      }
    },
  },
  beforeCreate() {

  },
  created() {

  },
  apollo: {
    busOrdersPage: {
      query: require('@/graphql/bus/query/busOrdersPage.gql'),
      variables(){
        return {
          campaignStatus: "2",
          sort: this.selectedSortValue || undefined,
          search: this.searchBoxValue || undefined,
          orderStatus: undefined,
          channelStatus: undefined,
          page: this.currentPage.toString() || "1"
        }
      },
      loadingKey: 'loading',
      async result(data) {
        const {busOrdersPage} = data.data
        if (busOrdersPage){
           await this.mapData(busOrdersPage)
        }else {
          this.$router.push({ name: `500` })
        }
      } 
    }
  },
  beforeMount() {

  },
  mounted() {
    const { page } = this.$route.query
    if(page){
      this.currentPage = parseInt(page)
    }
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    mapData(busOrdersPage){
      console.log
      this.resetData()
      var body = []
      let meta = busOrdersPage.meta
      let result = busOrdersPage.busOrders
      result.forEach(res => {
          let paymentData = {}
          if (res.payment != null && res.payment.statusDisplay != null){
            paymentData = this.getPaymentData(res.payment.statusDisplay)
          } else{
            paymentData = {value:'pending', label:'PENDING'}
          }
          
          let campaignStatus = {}
          if (res.campaign.status != null && res.campaign.statusDisplay !=null){
            campaignStatus = this.getCampaignStat(res.campaign.statusDisplay)
          } else{
            campaignStatus = {value:'active', label:'ACTIVE'}
          }

          let valuesData = [
            { label: res.number, value: res.id},
            { value: res.campaign.companyName },
            { value: res.campaign.title },
            { value: campaignStatus, label: campaignStatus.toUpperCase() },
            { value: parseInt(res.campaign.totalPrice) || 0},
            { value: paymentData.value, label:paymentData.label},
            { value: res.campaign.start},
            { value: res.campaign.end},
            { value: res.UpdateAt}
          ]
          body.push({values:valuesData})
        });
        this.data.body = body
        this.maxPage = meta.maxPage
        this.count = meta.count
    },
    resetData(){
      this.data.body = []
    },
    getPaymentData(statusDisplay){
      let payment = statusDisplay.toLowerCase()
      let res = {}
      switch(payment){
        case `pending`:
          res = {value: payment, label: 'PENDING'}
          break
        case `afterpay`:
          res = {value: payment, label: 'AFTERPAY'}
          break
        case `paid`:
          res = {value: payment, label: 'PAID'}
          break
        case `downpayment`:
          res = {value: payment, label: 'DOWNPAYMENT'}
          break
        case `partially`:
          res = {value: payment, label: 'PARTIALLY'}
          break
      }
      return res
    },
    getCampaignStat(stat){
      let status = "cancel"
      switch (stat) {
        case `Draft`:
          status = "draft"
          break;
        case `Verifying`:
          status = "verifying"
          break;
        case `Active`:
          status = "active"
          break;
        case `Cancel`:
          status = "canceled"
          break;
        case `Expired`:
          status = "expired"
          break;
        case `Deleted`:
          status = "deleted"
          break;
        case `Dormant`:
          status = "dormant"
          break;      
      }
      return status
    },
    changePage (selected) {
      history.pushState(null, null, '?page=' + selected);
      this.currentPage = selected
      this.$apollo.queries.busOrdersPage.refetch()
    },
    selectPage(item) {
      this.selectedPage = item
      this.$apollo.queries.busOrdersPage.refetch()
    },
  }
}

</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
<style lang='scss'>
.activeOrder {
  .table {
    table {
      thead {
        tr {
          background-color: #fafafa;
          td {
            span {
              font-size:12px;
            }
          }
        }
      }
      tbody {
        tr {
          td {
            .text {
              font-size:15px;
              max-width: 200px;
            }
            .date {
              font-size:15px;
            }
            .money {
              text-align:left;
              span {
                font-size:15px;
              }
            }
          }
        }
      }
    }
	}
}
.standardInput {
  font-size: 15px
}
</style>

